<template>
  <van-popup
    v-model="isShowSelectableProvince"
    round
    position="bottom"
    :style="{ height: '50%' }"
  >
    <LongListPicker
      ref="longListPicker"
      :options="provinceListOnShow"
      title="选择省份"
      label-key="provinceName"
      value-key="provinceId"
      :offset="50"
      :error="isListError"
      finished
      @on-cancel="isShowSelectableProvince = false"
      @on-confirm="handleSelectProvince"
      @on-search="handleSearchProvince"
    />
  </van-popup>
</template>

<script>
import Popup from 'vant/lib/popup';
import LongListPicker from '@/components/LongListPicker';
import STATUS from '@/constants/status';

import createWalletApi from '@/api/createWallet';

import 'vant/lib/popup/style';

export default {
  name: 'ProvincePicker',
  components: {
    LongListPicker,
    [Popup.name]: Popup,
  },
  data() {
    return {
      isShowSelectableProvince: false,
      isListError: false,
      provinceList: [],
      provinceListOnShow: [],
    };
  },
  methods: {
    loadProvinceList() {
      this.getProvinceList();
      this.isShowSelectableProvince = true;
      if (this.$refs.longListPicker) {
        this.$refs.longListPicker.clearSearchKeyword();
      }
    },

    async getProvinceList() {
      this.loading = true;
      try {
        const { respCode, data = [], respMsg } = await createWalletApi.getProvinceList({
          pageSize: 15,
          pageNum: 1,
          keyword: '',
        });

        if (respCode !== STATUS.SUCCESS) throw new Error(respMsg);

        this.provinceList = data;
        this.provinceListOnShow = data;
      } catch (e) {
        this.$dialog.toast(e.message || '操作失败');
      } finally {
        this.loading = false;
      }
    },

    handleSelectProvince(province) {
      this.isShowSelectableProvince = false;
      this.$emit('on-select-province', province);
    },

    handleSearchProvince(keyword) {
      this.provinceListOnShow = this.provinceList.filter((province) => province.provinceName.indexOf(keyword) !== -1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
